import { z } from 'zod'

export const tmaisFaqFormSchema = z.object({
  question: z
    .string()
    .trim()
    .min(1, { message: 'Campo obrigatório' })
    .max(256, { message: 'Máximo de 256 caracteres' }),
  answer: z
    .string()
    .trim()
    .min(1, { message: 'Campo obrigatório' })
    .max(1024, { message: 'Máximo de 1024 caracteres' }),
  position: z
    .string()
    .trim()
    .min(1, { message: 'Campo obrigatório' })
    .regex(/^\d+$/, { message: 'Informe um número inteiro' })
    .refine((val) => Number(val) >= 0, { message: 'Valor mínimo: 0' })
    .refine((val) => Number(val) <= 1000, { message: 'Valor máximo: 1000' }),
})

export type TmaisFaqFormSchema = z.infer<typeof tmaisFaqFormSchema>
